import { Card } from '@latitude/card';
import { FormInput, FormSelect, useFormContext } from '@latitude/form';
import type { SelectOption } from '@latitude/select';

type Props = {
  countryOptions: SelectOption[];
  isCountryOptionsLoading: boolean;
};

function OrganizationDetailsContent({
  countryOptions,
  isCountryOptionsLoading,
}: Props) {
  const { control } = useFormContext();

  return (
    <Card className="flex w-full flex-col gap-6">
      <FormInput
        control={control}
        name="organizationName"
        label="Organization legal name"
        inputSize="medium"
      />
      <FormSelect
        control={control}
        name="organizationCountry"
        label="Country of incorporation"
        options={countryOptions}
        optional={false}
        loading={isCountryOptionsLoading}
      />
    </Card>
  );
}

export { OrganizationDetailsContent };
